import axios from "axios";
import { apiAddress } from "../../config/server";
import { IUserActivity } from "../../types/activity/Activity";
import { IPerson } from "../../types/persons/person";

export default class ActivitiesApi {
  static ActivitiesApiAddress = `${apiAddress}/api/activities/admin`;

  static getMyActivities(): Promise<{
    activities: IUserActivity<any>;
    persons: IPerson[];
  }> {
    return axios.get(this.ActivitiesApiAddress).then((response) => {
      if (response.status == 200 && response.data.success) {
        const { data } = response.data;
        return {
          activities: response.data.data,
          persons: response.data.persons,
        };
      }
      throw new Error(response.data.message);
    });
  }
}
